export default {
  'get-list': {
    method: 'post',
    url: '/vehicle/list'
  },
  all: {
    method: 'post',
    url: '/vehicle/all'
  },
  getById: {
    method: 'get',
    url: '/vehicle/ID'
  },
  delete: {
    method: 'delete',
    url: '/vehicle'
  },
  add: {
    method: 'post',
    url: '/vehicle'
  },
  edit: {
    method: 'put',
    url: '/vehicle/ID'
  },
  select: {
    method: 'get',
    url: '/vehicle/find'
  },
  changeStatus: {
    method: 'post',
    url: 'vehicle/change-status'
  },
  archive: {
    method: 'delete',
    url: 'vehicle/archive'
  },
  restore: {
    method: 'put',
    url: 'vehicle/restore'
  },
  archiveDocument: {
    method: 'delete',
    url: 'vehicle/document/archive'
  },
  restoreDocument: {
    method: 'put',
    url: 'vehicle/document/restore'
  },
  archivePlugin: {
    method: 'delete',
    url: 'vehicle/plugin/archive'
  },
  restorePlugin: {
    method: 'put',
    url: 'vehicle/plugin/restore'
  },
  stopExploit: {
    method: 'put',
    url: '/vehicle/ID/stop-exploit'
  },
  openExploit: {
    method: 'put',
    url: '/vehicle/ID/open-exploit'
  },
  getGPS: {
    method: 'get',
    url: '/vehicle/gps/ID'
  },
  getGPSAll: {
    method: 'get',
    url: '/vehicle/gps/all'
  }
}
